// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__592tD","textareaInput":"styles_textareaInput__I+XVU"};